<div class="border_wrapper" style="height: 100%; position: relative">
  <div class="powertrain_name">
    {{ powertrainName }}
  </div>
  <div class="justify_center_flex" [ngStyle]="{'justify-content':client_id=='608'?'center':'space-between'}">
    <div class="cursor-move flex_9" [ngStyle]="{
        position: 'relative',
        width:client_id=='608'?'50%':'85%'
      }">
      <!-- Place .img here for the image -->
      <img [src]="powertrainImg" class="img" style="width:100%"
        [ngStyle]="{'height':client_id=='502' || client_id=='608'?'500px':'205px'}" />

      <!-- Sensors -->
      <!-- class="sensor rounded-lg center_flex" -->
      <div class="new_sensor_style rounded-2 " [matTooltip]="showTooltip(sensor)" [matTooltipClass]="'tooltip_1'"
        *ngFor="let sensor of sensors" [ngStyle]="{
          top: sensor.yPercentage + '%',
          left: sensor.xPercentage + '%',
          position: 'absolute',
          'background-color': sensor.color,
          'cursor': 'pointer'
        }" (click)="onSensorClick(sensor)">
        <!-- [ngClass]="{
          'pulsing-circle': sensor.color == '#ff2a1b',
          border_yellow: sensor.color == '#faa700',
          border_green: sensor.color == '#72ff13'
        }" -->
        <!-- <div class="sensor_no"> -->
        <div class="sensor_no">
          <!-- {{ sensor.sensor_number == 0 ? "B" : sensor.sensor_number }} -->
          <!-- {{ sensor.sensorMarker }} -->
          {{ sensor.sensorDNames }}
        </div>
        <img src="./assets/wifion.png" width="16" height="16" alt=""
          *ngIf="sensor.asset_status == 1 || sensor.asset_status == 0" />
        <img src="./assets/wifioff.png" width="16" height="16" alt="" *ngIf="sensor.asset_status == 2 " />
      </div>
    </div>
    <div class="m-2">
      <div class="flex_1 phy_images_box" *ngFor="let i of powertrainPhyImgs">
        <div (click)="openImage(i)" class="physical_img_box">
          <img class="w-100 h-100" [src]="i.url" alt="" />
        </div>
      </div>
      <!-- <div class="flex_1 phy_images_box" *ngIf="powertrainPhyImgs.length < 4">
        <div >
         
        </div>
      </div> -->
    </div>
  </div>
  <div class="powertrain_eye_icon" (click)="opnePowertrainImageModal()">
    <!-- <img src="./assets/powertrain-images/edit.png" alt="edit-icon" /> -->
    <mat-icon>remove_red_eye</mat-icon>
  </div>
  <div class="powertrain_edit_icon" (click)="editPowertrain()">
    <!-- <img src="./assets/powertrain-images/edit.png" alt="edit-icon" /> -->
    <mat-icon>edit</mat-icon>
  </div>
  <div class="powertrain_add_icon" *ngIf="powertrainPhyImgs.length<4" (click)="addImage()">
    <mat-icon>add_photo_alternate</mat-icon>
  </div>
  <div class="powertrain_add_icon" *ngIf="(overall_status == 1)" (click)="addImage()">
    <div class="asset_running_dot blue_bg" matTooltip="Asset Running" [matTooltipClass]="'tooltip1'"></div>
  </div>
  <div class="powertrain_add_icon" *ngIf="(overall_status != 1)" (click)="addImage()">
    <div class="asset_running_dot gray_bg" matTooltip="Asset Idle" [matTooltipClass]="'tooltip1'"></div>
  </div>
</div>

<app-powertrain-modal [type]="'powertrain_image'" [data]="false_Claims_metrics" [subsystem_id]="subsystem_id"
  *ngIf="showModal" (closePowertrainImgModal)="closeModal($event)"></app-powertrain-modal>

<app-powertrain-modal [type]="'powertrain_phy_image'" [data]="selectedImg" *ngIf="showImgModal"
  (closePowertrainPhyImgModal)="closeModal($event)"></app-powertrain-modal>

<app-powertrain-modal [type]="'img_modal'" [subsystem_id]="subsystem_id" *ngIf="addPhyImgModal"
  (closePowertrainPhyImgModal)="closeModal($event)"></app-powertrain-modal>